import React from 'react'
import {
  withProps,
} from 'recompose'
import pick from 'lodash/pick'
import isArray from 'lodash/isArray'
import isString from 'lodash/isString'
import isNil from 'lodash/isNil'
import reduce from 'lodash/reduce'
import { filterValidStyles, flattenObject } from './elementUtils'
import getElementBackgroundStyle from './elementBackgroundStyle'

const flatObject = (val) => filterValidStyles(flattenObject(val))
const mergeStyles = (defaultStyles, deviceStyles) => ({
  ...flatObject(defaultStyles),
  ...flatObject(deviceStyles),
})

export const withElement = () => withProps(({
  screen,
  background = {},
  defaultGutter = {}, // { gutter: 20 }
  deviceGutter = {},
  defaultContent = {},
  deviceContent = {},
  defaultStyles = {},
  deviceStyles = {},
  defaultSettings = {},
  deviceSettings = {},
}) => {
  const elementBackgroundStyle = getElementBackgroundStyle(background)
  // styles and settings can be customized in each device
  // console.log('screen', screen)
  // console.log('defaultContent', defaultContent)
  // console.log('deviceContent', deviceContent)
  // console.log('overrideDefaultValue', overrideDefaultValue(defaultContent, deviceContent[screen]))
  // console.log('overrideDefaultValue', overrideDefaultValue(
  //   filterValidStyles(defaultSettings),
  //   filterValidStyles(deviceSettings[screen])
  // ))
  // console.log('filterValidStyles(defaultSettings),', filterValidStyles(defaultSettings),)

  // gutter = { gutter: ... }
  const gutter = overrideDefaultValue(defaultGutter, deviceGutter[screen])
  return {
    style: { ...mergeStyles(defaultStyles, deviceStyles[screen]), ...elementBackgroundStyle },
    content: overrideDefaultValue(defaultContent, deviceContent[screen]),
    ...gutter,
    settings: overrideDefaultValue(
      filterValidStyles(defaultSettings),
      filterValidStyles(deviceSettings[screen]),
    ),
  }
})

const overrideDefaultValue = (defaultValue, deviceValue) => {
  if (!deviceValue) {
    return defaultValue
  }
  // in order to override in device, default value must valid
  return reduceValue(defaultValue, deviceValue)
}

const reduceValue = (reducedValue, mapValue) => reduce(reducedValue, (result, val, key) => {
  const overrideValue = mapValue[key]
  if (isInvalidValue(overrideValue)) {
    return { ...result, [key]: val }
  }
  return { ...result, [key]: overrideValue }
}, {})

const isInvalidValue = (val) => {
  if (isNil(val)) {
    return true
  } else if (isArray(val) && val.length > 0) {
    return false
  } else if (isString(val) && val !== '') {
    return false
  }
  return false
}



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/withElement.js